/**
 * Created by lihanying on 2017/6/20.
 */
import { combineReducers } from 'redux' // 利用combineReducers 合并reducers
import { routerReducer } from 'react-router-redux' // 将routerReducer一起合并管理
import getPortal from './containers/Portal/reduce'
import getWechat from './containers/WechatAuth/reduce'
import getHome from './containers/Home/reduce'
import getClubUsers from './containers/ClubUsers/reduce'
import getClubList from './containers/ClubList/reduce'
import getClubAdd from './containers/ClubAdd/reduce'
import getClubEmployee from './containers/ClubEmployee/reduce'
import getClubBusiness from './containers/ClubBusiness/reduce'
import getClubMember from './containers/ClubMember/reduce'
import getClubMemberList from './containers/ClubMemberList/reduce'
import getClubBlacklist from './containers/ClubBlacklist/reduce'
import getClubTable from './containers/ClubTable/reduce'
import getClubProfession from './containers/ClubProfession/reduce'
import getClubCommodity from './containers/ClubCommodity/reduce'
import getClubCommodityType from './containers/ClubCommodityType/reduce'
import getClubLevel from './containers/ClubLevel/reduce'
import getClubWallet from './containers/ClubWallet/reduce'
import getClubInfo from './containers/ClubInfo/reduce'
import getClubStream from './containers/ClubStream/reduce'
import getClubDeploy from './containers/ClubDeploy/reduce'
import getClubStorage from './containers/ClubStorage/reduce'
import getClubRepertory from './containers/ClubRepertory/reduce'
import getClubMarket from './containers/ClubMarket/reduce'
import getClubExpend from './containers/ClubExpend/reduce'
import getClubStandby from './containers/ClubStandby/reduce'
import getClubRevenue from './containers/ClubRevenue/reduce'
import getClubRevenueNew from './containers/ClubRevenueNew/reduce'
import getClubShift from './containers/ClubShift/reduce'
import getClubTableStatus from './containers/ClubTableStatus/reduce'
import getAdvertManage from './containers/AdvertManage/reduce'
import getCardManage from './containers/CardManage/reduce'
import getConsume from './containers/Consume/reduce'
import getAdv from './containers/CheckOutAdvManage/reduce'
import getEmpManager from './containers/ClubEmployeeManager/reduce'
import getTableUsageStatistics from './containers/TableUsageStatistics/reduce'
export default combineReducers({
  getPortal,
  getWechat,
  getHome,
  getClubUsers,
  getClubList,
  getClubAdd,
  getClubEmployee,
  getClubBusiness,
  getClubMember,
  getClubMemberList,
  getClubBlacklist,
  getClubTable,
  getClubProfession,
  getClubCommodity,
  getClubCommodityType,
  getClubLevel,
  getClubWallet,
  getClubInfo,
  getClubStream,
  getClubDeploy,
  getClubStorage,
  getClubRepertory,
  getClubMarket,
  getClubExpend,
  getClubStandby,
  getClubRevenue,
  getClubRevenueNew,
  getClubShift,
  getClubTableStatus,
  getAdvertManage,
  getCardManage,
  getConsume,
  getAdv,
  getEmpManager,
  getTableUsageStatistics,
  routing: routerReducer,
})



// WEBPACK FOOTER //
// ./src/reduce.js